<template>
	<div
		class="operator-cell"
		:class="{ 'operator-has-multi-values': shouldAddBottomMargin }"
	>
		<Dropdown
			:value="filterData.operator"
			:items="operatorItems"
			placeholder="Select operator"
			:disabled="!userFullPermissions"
			:class="{ 'operator-has-multi-values': shouldAddBottomMargin }"
			small
			hide-details
			@input="handleOperatorChange"
		/>
	</div>
</template>

<script>
import Dropdown from '../../../../../../../shared/components/dropdown.vue'

export default {
	name: 'filter-operator-cell',
	components: {
		Dropdown
	},
	props: {
		field: {
			type: Object,
			required: true
		},
		filterData: {
			type: Object,
			required: true
		},
		editingCell: {
			type: Object,
			default: null
		},
		userFullPermissions: {
			type: Boolean,
			default: false
		},
		lookupData: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		operatorItems () {
			const operators = this.getOperatorsForField(this.field)
			return [
				...operators
			]
		},
		shouldAddBottomMargin () {
			const rawOp = (this.filterData?.operator ?? '').toString()
			// Normalize: lowercase and remove spaces/underscores/dashes
			const op = rawOp.toLowerCase().replace(/[\s_-]+/g, '')
			const multiOps = new Set(['includes', 'doesnotinclude', 'in', 'notin'])
			const isTargetOp = multiOps.has(op)
			const val = this.filterData?.value
			let hasValues = false
			if (Array.isArray(val)) {
				hasValues = val.length > 0
			} else if (val !== null && val !== undefined) {
				const s = String(val).trim()
				hasValues = s.length > 0
			}
			return isTargetOp && hasValues
		}
	},
	methods: {
		handleOperatorChange (value) {
			this.$emit('filter-change', {
				fieldName: this.field.fieldName,
				field: 'operator',
				value: value
			})
		},
		getOperatorsForField (field) {
			// Use API-provided operators (matches original integration-service-query-builder.vue)
			if (!this.lookupData || !this.lookupData.outputFilters || !Array.isArray(this.lookupData.outputFilters)) {
				return []
			}

			// Get the field's type friendly name
			const fieldType = field.typeFriendlyName || field.dataType || 'String'

			// Filter and map operators for this field type (exact match from original implementation)
			return this.lookupData.outputFilters
				.filter(filter => filter.typeFriendlyName === fieldType)
				.map(filter => ({
					text: filter.friendlyOperator,
					value: filter.operator
				}))
		}
	}
}
</script>

<style lang="scss" scoped>
.operator-cell {
	padding: 8px !important;
	vertical-align: middle;
	position: relative;
}

.operator-has-multi-values {
	margin-bottom: 30px; /* creates space to align with the value field when chips are shown */
}

.operator-dropdown {

	:deep(.v-input__slot) {
		padding: 0 8px !important;
		min-height: 36px !important;
	}

	:deep(.v-select__selections) {
		padding: 0 !important;
		min-height: 36px !important;
		display: flex;
		align-items: center;
	}

	:deep(.v-input__append-inner) {
		margin-top: 0 !important;
		align-self: center;
	}

	:deep(.v-text-field__details) {
		display: none !important;
	}
}
</style>
